module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-greek242.e15ea3d.woff2";